module.exports = __webpack_public_path__ + "media/c5.c02f3e73.mp3";